module.exports = __webpack_public_path__ + "img/34_51.6086577c.png";